import authentication from "@irati/auth";
import { ShareOptionValues } from "../enums";
export var EVERYONE = "everyone";
export var PRIVATE = "private";
export var PROPERTY = "share";
export var SPECIFIC_TEAMS = "specific_teams";
export var TEAMS = "teams";
export var EVERYONE_OPTION = function (intl) { return ({
    label: intl.formatMessage({ id: "reward.fields.share.option.everyone" }, { tenantName: authentication.userTenant().public_name }),
    value: ShareOptionValues.EVERYONE
}); };
export var PRIVATE_OPTION = function (intl) { return ({
    label: intl.formatMessage({ id: "reward.fields.share.option.private" }),
    value: ShareOptionValues.PRIVATE
}); };
export var SPECIFIC_TEAMS_OPTION = function (intl) { return ({
    label: intl.formatMessage({ id: "reward.fields.share.option.specific" }),
    value: SPECIFIC_TEAMS
}); };
export var TEAMS_OPTION = function (intl) { return ({
    label: intl.formatMessage({ id: "reward.fields.share.option.teams" }),
    value: ShareOptionValues.TEAMS
}); };
export var DEFAULT_OPTIONS = function (intl) { return [EVERYONE_OPTION(intl), TEAMS_OPTION(intl), PRIVATE_OPTION(intl)]; };
export default (function (intl, canShareWithEveryone, canBeSharedWithTeams) {
    if (canShareWithEveryone === void 0) { canShareWithEveryone = false; }
    if (canBeSharedWithTeams === void 0) { canBeSharedWithTeams = false; }
    var options = [];
    if (canShareWithEveryone) {
        options.push(EVERYONE_OPTION(intl));
    }
    if (canBeSharedWithTeams) {
        options.push(TEAMS_OPTION(intl));
    }
    options.push(PRIVATE_OPTION(intl));
    return options;
});
